import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/logo/city-battery-horizontal.svg" 
                alt="city-battery.energy" 
                className="h-[26px] sm:h-[32px] w-auto"
              />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-cyan-700 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Zurück zur Startseite</span>
              <span className="sm:hidden">Zurück</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-slate-800 mb-8">Impressum</h1>
          
          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-slate-600 leading-relaxed">
              <strong>DSG Beteiligungs- und Verwaltungsgesellschaft mbH</strong><br />
              (Betreiber von <a href="https://city-battery.energy/" className="text-cyan-700 hover:text-cyan-800">https://city-battery.energy/</a>)
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Kontakt</h2>
            <p className="text-slate-600 leading-relaxed">
              E-Mail: <a href="mailto:it@city-battery.energy" className="text-cyan-700 hover:text-cyan-800">it@city-battery.energy</a><br /><br />
              <strong>Telefon:</strong><br />
              <a href="tel:+4917693127245" className="text-cyan-700 hover:text-cyan-800">+49 176 93127245</a><br />
              <a href="tel:+493071047955" className="text-cyan-700 hover:text-cyan-800">+49 30 71047955</a>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Registereintrag</h2>
            <p className="text-slate-600 leading-relaxed">
              Eintragung im Handelsregister<br /><br />
              Registergericht: Amtsgericht Berlin-Charlottenburg<br />
              Registernummer: HRB 165868 B
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-slate-600 leading-relaxed">
              DSG Beteiligungs- und Verwaltungsgesellschaft mbH
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">EU-Streitschlichtung</h2>
            <p className="text-slate-600 leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-cyan-700 hover:text-cyan-800">https://ec.europa.eu/consumers/odr/</a><br /><br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p className="text-slate-600 leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Haftung für Inhalte</h2>
            <p className="text-slate-600 leading-relaxed">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br /><br />
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Haftung für Links</h2>
            <p className="text-slate-600 leading-relaxed">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.<br /><br />
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Urheberrecht</h2>
            <p className="text-slate-600 leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.<br /><br />
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
          </section>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">© 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik</p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-sm text-slate-500 hover:text-cyan-700">Impressum</Link>
              <Link to="/datenschutz" className="text-sm text-slate-500 hover:text-cyan-700">Datenschutz</Link>
              <Link to="/barrierefreiheit" className="text-sm text-slate-500 hover:text-cyan-700">Barrierefreiheit</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
